import { selectExternalInvitationPublic } from '@/domain/external-invitation/external-invitations.selectors';
import {
  EMPTY_IMPACT_STATS_PUBLIC,
  ImpactCo2AnswerStatsPublic,
} from '@/domain/impact-stats/entities/stats-public.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  projectId: number;
};

export const getImpactStatsPublic = createAppAsyncThunk(
  'impactStats/getImpactStatsPublic',
  async (
    params: Params,
    { getState, extra: { impactStatsGateway, snackbarGateway } },
  ): Promise<ImpactCo2AnswerStatsPublic> => {
    const externalInvitation = selectExternalInvitationPublic(getState());
    if (!externalInvitation) {
      return EMPTY_IMPACT_STATS_PUBLIC;
    }
    const invitationCode = externalInvitation.code;
    try {
      return await impactStatsGateway.getStatsPublic(
        params.projectId,
        invitationCode,
      );
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactStatsPublic.Message.error'));
}
